import React, { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

export default function GlobalMaintenanceWrapper({ children }: { children: React.ReactNode }) {
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const docRef = doc(db, 'settings', 'global');
    const unsubscribe = onSnapshot(docRef, (snap) => {
      if (snap.exists() && snap.data().isMaintenance) {
        setIsMaintenance(true);
      } else {
        setIsMaintenance(false);
      }
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  if (loading) return null;

  // Sadece ana sayfa (Front-end) rotalarını kaplamak mantıklı, /admin içine girmemeli
  // Fakat App düzeyinde sarıyorsak şimdilik direkt basabiliriz, admin'e de kapalıysa o zaman
  // sadece path bazlı engellemek gerekir. 
  
  if (isMaintenance && !window.location.pathname.startsWith('/admin')) {
    return (
      <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center p-4 text-center">
        <img 
          src="https://static.readdy.ai/image/462a574349d19c517babfc55bf63e079/c8ac21bc970c8b7e4f4c5b80839b9d5d.png" 
          alt="KARE YAPI" 
          className="w-32 brightness-0 invert opacity-50 mb-8"
        />
        <i className="ri-tools-line text-6xl text-red-600 mb-6 block animate-pulse"></i>
        <h1 className="text-3xl md:text-5xl font-black text-white mb-4 uppercase tracking-widest" style={{ fontFamily: 'Raleway, sans-serif' }}>
          Sistem Bakımda
        </h1>
        <p className="text-zinc-400 max-w-lg text-sm leading-relaxed">
          KARE YAPI İnşaat web sitemizde kısa süreli bir altyapı güncellemesi yapılmaktadır. Size daha iyi hizmet verebilmek için çalışıyoruz, lütfen daha sonra tekrar deneyiniz.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
